import { Component, Input, OnInit } from '@angular/core';
import * as echarts from 'echarts';
import { EChartsOption } from 'echarts';
import { ChatEnrichmentConfigService } from 'src/app/pages/ai/configs/chat-enrichment.config';
import { ChatCommand } from 'src/app/pages/ai/services/ai-chat-proxy.service';
import { INSTRUCTIONS } from 'src/app/pages/ai/services/instructions.constants';
import { GeminiSchemaType, ProxyAiResponseSchemaService } from 'src/app/pages/ai/services/proxy-ai-response-schema.service';
import { ContactDto } from 'src/portal/contact-api/models/contact-dto';
@Component({
  selector: 'profile-skills',
  templateUrl: './profile-skills.component.html',
  styleUrls: ['./profile-skills.component.scss']
})
export class ProfileSkillsComponent implements OnInit {
  private _contact: ContactDto;

  @Input()
  set contact(value: ContactDto) {
    console.log('set contact', value);
    this._contact = value;
    if (value) {
     // this.isLoading = true;
     // this.setContact(value); // обработка данных
    }
  }

  get contact(): ContactDto {
    return this._contact;
  }

  isLoading = false;

  chartOption: EChartsOption =  {
    title: {
      text: ''
    },
    legend: {
      data: ['Your Company Average','User Score', 'People In Job Percentage'],

      top: 0,
      left: 'left',
      orient: 'vertical',
    },
    radar: {
       shape: 'circle',
      indicator: [
        { name: 'DBMS Concepts', max: 6500},
        { name: 'Algorithms', max: 16000},
        { name: 'Problem Solving', max: 30000},
        { name: 'Comunication Skills', max: 38000},
        { name: 'Coding', max: 52000},
        { name: 'MySql', max: 25000}
      ]
    },
    series: [
      {
        name: 'Budget vs spending',
        type: 'radar',
        data: [
          {
            value: [5200, 6500, 23500, 28000, 45000, 19000],
            name: 'Your Company Average'
          },
          {
            value: [4200, 3000, 20000, 35000, 50000, 18000],
            name: 'User Score'
          },
          {
            value: [5000, 14000, 28000, 26000, 42000, 21000],
            name: 'People In Job Percentage',
            areaStyle: {
              color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                {
                  color: 'rgba(250, 200, 88, 0.1)',
                  offset: 0
                },
                {
                  color: 'rgba(250, 200, 88, 0.7)',
                  offset: 1
                }
              ])
            }
          }
        ]
      }
    ]
  };


  constructor(
    private proxyAiResponseSchemaService:ProxyAiResponseSchemaService,
    private enrichmentConfigService: ChatEnrichmentConfigService,
  ) {
  }

  showAll: boolean = false;

  get displayedItems() {
    return this.showAll ? this.contact?.purchasedData?.profile_data?.profile_expertises : this.contact?.purchasedData?.profile_data?.profile_expertises.slice(0, 3);
  }

  toggleShowAll() {
    this.showAll = !this.showAll;
  }

  ngOnInit(): void {

  }

  async setContact(contact: ContactDto) {

    // const data = await this.getCompanyData();
    // const result = await this.getProfileCompanySkills(contact,data);


    // console.log(result);

    // this.configurateChart(result.skills);

  }

  async getSkills(contact: ContactDto) {
      try {
        const result = await this.proxyAiResponseSchemaService.analyzePrompt(
          INSTRUCTIONS.systemInstructionsSkills,
          JSON.stringify(contact),
          GeminiSchemaType.Skills
        );
        return result;

      } catch (error) {
        console.error('Error generating skills:', error);
        return [];
      }
    }


  async getProfileCompanySkills(profileData :any,buyercaddyData:any) {
      try {
        const result = await this.proxyAiResponseSchemaService.analyzePrompt(
          INSTRUCTIONS.systemInstructionProfileAndCompanyRate,
          'User data:'+JSON.stringify(profileData)  + '/n' + 'Data for company muranosoft.com:' + JSON.stringify(buyercaddyData),
          GeminiSchemaType.Skills
        );
        return result;

      } catch (error) {
        console.error('Error generating skills:', error);
        return [];
      }
    }


  private async getCompanyData() {
      const config = this.enrichmentConfigService.config[ChatCommand.FindEmployees];
      if (!config) return;
      return await config.fetchDataFn("Select all expertises for the company muranosoft.com, separate all expertises and aggregate them. Delimiter ';'",100)
    }




//     private configurateChart(skills) {
//       console.log(skills);

//       const labels = skills.map(skill => skill.skillName);
//       const userValues = skills.map(skill => skill.userRate);
//       const companyValues = skills.map(skill => skill.companyRate);
//       const peopleInJobValues = skills.map(skill => skill.companyRate - 100);

//       const userDescriptions = skills.map(skill => skill.userRateDescription || '');
//       const companyDescriptions = skills.map(skill => skill.companyRateDescription || '');

//       const maxValues = labels.map((_, index) => {
//         const max = Math.max(userValues[index], companyValues[index], peopleInJobValues[index]);
//         return Math.ceil(max * 1.2);
//       });

//       const indicators = labels.map((label, i) => ({
//         name: label,
//         max: maxValues[i],
//       }));

//       this.chartOption = {
//         title: {
//           text: ''
//         },
//         legend: {
//           data: ['Your Company Average', 'User Score', 'People In Job Percentage'],
//           top: 0,
//           left: 'left',
//           orient: 'vertical',
//         },
//         tooltip: {
//           trigger: 'item',
// //           formatter: (params) => {
// // console.log(params)
// //             // Определяем правильное значение и описание
// //             let description = '';
// //             if (params.name === 'User Score') {
// //               description = skills.map((s, i) =>
// //                 `<b>${s.skillName}:</b> ${s.userRate}<br><i>${s.userRateDescription}</i>`
// //               ).join('<br><br>');
// //             } else if (params.name === 'Your Company Average') {
// //               description = skills.map((s, i) =>
// //                 `<b>${s.skillName}:</b> ${s.companyRate}<br><i>${s.companyRateDescription}</i>`
// //               ).join('<br><br>');
// //             } else if (params.name === 'People In Job Percentage') {
// //               description = skills.map((s, i) =>
// //                 `<b>${s.skillName}:</b> ${s.companyRate - 100}`
// //               ).join('<br>');
// //             }
// //             console.log(`<b>${params.name}</b><br><br>${description}`);
// //             return `<b>${params.name}</b><br><br>${description}`;
// //           }
//         },
//         radar: {
//           shape: 'circle',
//           indicator: indicators
//         },
//         series: [
//           {
//             name: 'Skill Comparison',
//             type: 'radar',
//             data: [
//               {
//                 value: companyValues,
//                 name: 'Your Company Average'
//               },
//               {
//                 value: userValues,
//                 name: 'User Score',
//                 areaStyle: {
//                   color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
//                     { color: 'rgba(250, 200, 88, 0.1)', offset: 0 },
//                     { color: 'rgba(250, 200, 88, 0.7)', offset: 1 }
//                   ])
//                 }
//               },
//               {
//                 value: peopleInJobValues,
//                 name: 'People In Job Percentage'
//               }
//             ]
//           }
//         ]
//       };

//       this.isLoading = false;
//     }

}
